<template>
    <div class="book-body">
        <div class="book-top">
            <bookback :msg="backMsg"></bookback>
        </div>
        <div class="book-select">
            <div class="select-area">
                <div :class="{'has-select':selectFlag,'select-item':true}" @click="selectRead">{{$t("latestRead")}}</div>
                <div :class="{'has-select':!selectFlag,'select-item':true}" @click="selectLike">{{$t("bookMsg")}}</div>
            </div>
        </div>
        <!--书架内容区域-->
        <div class="book-con" v-show="selectFlag">
            <div class="book-item">
                <div class="con-item" v-for="(item,index) in lastRead" :key="index">
                    <div class="con-img" @click="go.goDetail(item.id)">
                        <img :src="item.img">
                    </div>
                    <div class="con-area" @click="go.goDetail(item.id)">
                        <div class="book-title">{{item.title}}</div>
                        <p class="book-info" v-html="item.abst"></p>
                        <div class="book-tags">
                            <div class="fonts-num">{{item.words>10000?parseInt(item.words/10000)+"万":item.words}}字</div>
                            <tags :tags="item.tags"></tags>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="book-con" v-show="!selectFlag">
            <div class="book-item">
                <div class="con-item" v-for="(item,index) in shelfList" :key="index">
                    <div class="con-img" @click="go.goDetail(item.id)">
                        <img :src="item.img">
                    </div>
                    <div class="con-area" @click="go.goDetail(item.id)">
                        <div class="book-title">{{item.title}}</div>
                        <p class="book-info" v-html="item.abst"></p>
                        <div class="book-tags">
                            <div class="fonts-num">{{item.words>10000?parseInt(item.words/10000)+"万":item.words}}字</div>
                            <tags :tags="item.tags"></tags>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--底部组件-->
        <div class="book-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import bookback from "@/components/common/bookback"
    import pagebottom from "@/components/common/pagebottom"
    import tags from "@/components/common/tags";
    export default {
        name: "mybook",
        components:{
            bookback,
            pagebottom,
            tags
        },
        data(){
            return{
                backMsg:this.$i18n.messages[`${this.$i18n.locale}`].bookMsg,
                selectFlag:true,
                lastRead:[],
                shelfList:[],
                page:0
            }
        },
        mounted:function(){
            this.selectRead();
        },
        methods:{
            //选择最近喜欢
            selectRead(){
                this.req.readList(this.page).then(res=>{
                    if(res&&res.data.list){
                        this.lastRead = res.data.list;
                    }
                })
                if(this.selectFlag) return;
                this.selectFlag = true;
            },
            selectLike(){
                this.req.shelflist().then(res=>{
                    if(res&&res.data.list){
                        this.shelfList = res.data.list;
                    }
                })
                if(!this.selectFlag) return;
                this.selectFlag = false;
            },
        }
    }
</script>

<style scoped>
    .book-body{
        width: 100%;
    }
    .book-top{
        width: 100%;
        height: auto;
        position: fixed;
        left: 0;
        top: 0;
    }
    .book-bottom{
        width: 100%;
        left: 0;
        bottom:0;
    }
    .book-select{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 1.41rem 0.3rem 0;
    }
    .select-area{
        width: 100%;
        height: 0.68rem;
        border: 0.01rem solid #ff1f4f;
        border-radius: 0.06rem;
        display: flex;
        justify-content: space-between;
    }
    .select-item{
        width: 50%;
        height: 100%;
        font-size: 0.3rem;
        line-height: 0.66rem;
        text-align: center;
        color: #ff1f4f;
    }
    .has-select{
        background: #ff1f4f;
        color: #ffffff;
    }
    .book-con{
        width: 100%;
    }
    .book-item{
        width: 100%;
        height: auto;
        padding: 0.2rem 0.3rem 0.4rem 0.3rem;
        box-sizing: border-box;
    }
    .con-item{
        width: 100%;
        height: auto;
        padding: 0.2rem 0rem;
        border-bottom: 0.02rem solid #e6e6e6;
        display: flex;
        justify-content: space-between;
    }
    .con-img{
        width: 1.74rem;
        height: 2.48rem;
        overflow: hidden;
    }
    .con-img img{
        display: block;
        width: 1.74rem;
        height: 2.48rem;
    }
    .con-area{
        width: 4.86rem;
        height: 2.48rem;
    }
    .book-title{
        font-size: 0.3rem;
        line-height: 0.3rem;
    }
    .book-info{
        font-size: 0.24rem;
        line-height: 0.44rem;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        padding-top: 0.1rem;
        color: #808080;
        height: 5em;
    }
    .book-tags{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.5rem;
    }
    .fonts-num{
        font-size: 0.24rem;
        line-height: 0.24rem;
        color: #808080;
    }
    .info-tags{
        display: flex;
        width: auto;
    }
    .tag-item{
        padding: 0.06rem 0.1rem;
        border: 0.01rem solid #919191;
        font-size: 0.2rem;
        line-height: 0.2rem;
        border-radius: 0.06rem;
        color: #666666;
        margin-left: 0.2rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/mybook.vue